<script>
    import sessionStore from 'store/session';
    import userStore from 'store/user';
    import { logoutAction } from 'domain/auth/auth.actions';
    import { useNavigate } from 'svelte-navigator';

    const navigate = useNavigate();

    let mobile;

    userStore.subscribe((value) => {
        mobile = value.mobile;
    });

    const logout = () => {
        logoutAction();
        navigate('/login');
    };
</script>

<div id="settings">
    <div class="row Personal-detail">
        <h2>Personal Information</h2>
        <p class="label">Name</p>
        <p class="name-detail">{$sessionStore.full_name}</p>
        <p class="label">Email Address</p>
        <p class="name-detail">{$sessionStore.email || 'Not yet set.'}</p>
    </div>

    <div class="row Personal-detail">
        <h2>Account Information</h2>
        <p class="label">My Number</p>
        <p class="name-detail">{mobile}</p>
        <p class="label">My Plan</p>
        <!-- <p class="name-detail">
            Monthly Subscription <a class="upgrade" href="#">Upgrade</a>
        </p> -->
    </div>

    <div class="row logout-row">
        <a href="#" class="logout-btn font-700" on:click={() => logout()}> Log Out </a>
    </div>
</div>

<style lang="scss">
    #settings {
        .Personal-detail {
            margin: 10px 20px !important;
            border-bottom: 1px solid rgba(17, 54, 69, 0.05);
            width: calc(100% - 40px);
            .label {
                font-size: 14px;
                font-weight: 400;
                color: #616c74;
                margin-top: 0px !important;
                margin-bottom: 5px !important;
            }
            h2 {
                font-weight: 700;
                font-size: 20px;
            }
            .name-detail {
                font-size: 16px;
                margin-top: 0px !important;
                color: #474b50;
                font-weight: 500;
            }
            .upgrade {
                color: #0e99d2;
                font-weight: 600;
                font-size: 14px;
                margin-left: 100px;
            }
        }
        .logout-row {
            margin: 10px 20px;
            display: block;
            float: left;
            .logout-btn {
                color: red;
                padding: 10px;
                border: 1px solid red;
                border-radius: 5px;
                width: 100px;
                display: block;
                text-align: center;
            }
        }
    }
</style>
